<template>
    <Teleport to="body">
        <div v-if="show" class="modal-overlay" @click.self="close">
            <div class="modal-window">
                <div class="modal-header">
                    <slot name="header"></slot>
                    <h2 class="am-no-visual"><span>Vorschau PDF Los</span></h2>
                    <button class="close-button" @click="close"><span class="icon icon-times"></span></button>
                </div>
                <div class="modal-content">
                    <div class="sidebar">
                        <slot name="sidebar"></slot>
                        <div class="modal__direction">
                            <input type="radio" id="front" name="direction" value="front" checked="" v-model="direction" @change="onDirectionChange"/>
                            <label for="front">
                                Vorderseite
                            </label>
                            
                            <input type="radio" id="back" name="direction" value="back" v-model="direction" @change="onDirectionChange" />
                            <label for="back">
                                Rückseite
                            </label>
                        </div>

                        <div class="modal__zoom">
                            <label for="zoom" class="font-bold">Bild vergrößern</label>
                            <input name="zoom" type="range" min="100" max="500" v-model="zoomPercentage" @change="zoomChanged" >
                            <div class="flex-container justify-c-between">
                                <span class="text-s font-bold">klein</span>
                                <span class="text-s font-bold">groß</span>
                            </div>
                        </div>
                    </div>
                    <div class="image-zoom-container">
                        <div class="image-container">
                            <img :src="currentImage" ref="imageEl" class="image" @load="onImageLoad" v-show="!loading" />
                            <div class="loading" v-if="loading">
                                <div class="spinner">
                                    <div class="circle circle-1">
                                        <div class="circle-inner"></div>
                                    </div>
                                    <div class="circle circle-2">
                                        <div class="circle-inner"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
  
  
<script>
import { ref, onUpdated } from 'vue';
import panzoom from 'panzoom';

export default {
    props: {
        show: Boolean,
        imageFrontSrc: String,
        imageBackSrc: String,
    },
    data() {
        return {
            loading: true,
            scale: 100,
            panzoomInstance: null,
            currentImage: this.imageFrontSrc,
        };
    },
    setup: () => {
        const panzoomInstance = ref(null);
        const imageEl = ref(null);
        const zoomPercentage = ref(100);

        const options = {
            bounds: true,
            boundsPadding: 0.5,
            initialX: 0,
            initialY: 0,
            initialZoom: 1,
            minZoom: 1,
            maxZoom: 5,
            transformOrigin: {x: 0, y: 0},
            beforeWheel: (e) => {
                const shouldIgnore = !e.altKey;
                return shouldIgnore;
            }
        };

        function transformPanzoom(e) {
            if (!panzoomInstance.value) {
                return;
            }

            const scale = e.getTransform().scale;

            if(scale < 1.2) {
                panzoomInstance.value.moveTo(0, 0);
            }

            zoomPercentage.value = scale*100;
        }

        onUpdated(() => {
            if (!imageEl.value || panzoomInstance.value) {
                return;
            }

            panzoomInstance.value = panzoom(imageEl.value, options);
            panzoomInstance.value.on('transform', transformPanzoom);

            document.body.style.overflow = 'hidden';
        });

        return {
             // eslint-disable-next-line
            panzoomInstance,
            imageEl,
            // eslint-disable-next-line
            zoomPercentage
        };
    },
    methods: {
        close() {
            this.$emit('update:show', false);

            document.body.style.overflow = 'auto';

            if (this.panzoomInstance) {
                this.panzoomInstance = null;
            }
        },
        zoomChanged() {
            if (this.panzoomInstance) {
                this.panzoomInstance.zoomAbs(0,0, this.zoomPercentage/100);
                this.panzoomInstance.moveTo(0, 0);
            }
        },
        onDirectionChange() {
            this.loading = true;

            switch(this.direction) {
                case 'front':
                    this.currentImage = this.imageFrontSrc;
                    break;
                case 'back':
                    this.currentImage = this.imageBackSrc;
                    break;
            }
        },
        onImageLoad() {
            this.loading = false;
        },
    },
    emits: [
        'update:show',
    ],
};
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 300;
}

.modal-window {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 80%;
    height: 80%;
    margin: 2.5% auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    z-index: 301;
    font-family: "Aktion Mensch regular";

    @media (max-width: 1024px) {
        width: 100%;
        height: 100%;
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    border-bottom: 1px solid #ccc;
    padding-left: 32px;
    padding-right: 32px;

    h2 {
        font-family: "Aktion Mensch Bold";
        font-size: 23px;

        span {
            color: var(--color-red);
        }
    }
}

.close-button {
    background: none;
    border: none;
    cursor: pointer;
    border: 1px solid var(--color-text);
    border-radius: 100%;
    color: var(--color-text);
    height: 32px;
    width: 32px;

    &:hover,
    &:focus {
        border-color: var(--color-red);
        color: var(--color-red);
    }

    .icon {
        position: relative;
        top: 0px;
        left: 1px;
        font-size: 20px;

        /* iOS only */
        @supports (-webkit-touch-callout: none) {
            top: 3px;
            left: -9px;
        }
    }
}

.modal-content {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: row;
    overflow: hidden;
    border: none;

    @media (max-width: 1024px) {
      flex-direction: column-reverse;
    }
}

.sidebar {
    flex: 0 0 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;

    @media (min-width: 1024px) {
        min-width: 376px;
    }
}

.zoom-slider {
    margin-top: auto;
    margin-bottom: 20px;
}

.image-zoom-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: var(--background-color);
    padding: 16px;

    @media (min-width: 1024px) {
        padding: 32px;
    }
}

.image-container {
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    transform-origin: top left;
    transition: transform 0.3s ease;
    overflow: hidden;
}

.image {
    height: auto;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
}

.loading {
    $duration: .7s;
    $size: 2rem;

    width: 41px;
    height: 41px;
    padding-top: 4px;

    .spinner * {
        box-sizing: border-box;
    }

    .spinner {
        display: inline-block;
        animation-name: anim-spinner;
        animation-duration: $duration;
        animation-iteration-count: infinite;
        animation-timing-function: linear;

        .circle {
        width: $size;
        height: calc($size/2);
        overflow: hidden;
        }

        .circle-inner {
        transform: rotate(45deg);
        border-radius: 50%;
        border: calc($size/8) solid var(--color-red);
        border-right: calc($size/8) solid transparent;
        border-bottom: calc($size/8) solid transparent;
        width: 100%;
        height: 200%;
        animation-name: anim-circle-1;
        animation-duration: $duration;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: cubic-bezier(.25, .1, .5, 1);
        }

        .circle-2 {
        transform: rotate(180deg);

        & .circle-inner {
            animation-name: anim-circle-2;
        }
        }

        @keyframes anim-circle-1 {
        from {
            transform: rotate(60deg);
        }
        to {
            transform: rotate(205deg);
        }
        }
        @keyframes anim-circle-2 {
        from {
            transform: rotate(30deg);
        }
        to {
            transform: rotate(-115deg);
        }
        }
        @keyframes anim-spinner {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
        }
    }
}
.modal__direction {
    display: flex;
    background-color: #ddd;
    height: 46px;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 0 6px;
    width: 100%;

    input {
        display: none;
    }

    label {
        display: flex;
        justify-content: center;
        height: 34px;
        width: 100%;
        margin-top: 6px;
        cursor: pointer;
        padding-top: 2px;
        padding-bottom: 2px;
        font-family: "Aktion Mensch Bold";
        color: var(--color-text);
        cursor: pointer;
    }

    [name="direction"]:checked + label {
        background-color: var(--color-white);
        border-radius: 20px;
    }
}

.modal__zoom {
    width: 100%;

    label {
        display: block;
        font-family: "Aktion Mensch Bold";
        color: var(--color-text);
    }

    [name="zoom"] {
        -webkit-appearance: none;
        width: 100%;
        border-radius: 4px;
        height: 4px;
        background: var(--background-color);
        margin: 16px 0;

        &::-moz-range-thumb  {
            -webkit-appearance: none;
            -moz-appearance: none;
            border-radius: 100%;
            background-color: var(--color-red);
            height: 24px;
            width: 24px;
            vertical-align: middle;
            border: none;
            cursor: pointer;
            margin-top: -10x;
        }

        &::-moz-range-track {
            -webkit-appearance: none;
            -moz-appearance: none;
            border-radius: 5px;
            background-color: var(--background-color);
            height: 5px;
            vertical-align: middle;
            margin: 0;
            padding: 0;
            border: none;
            cursor: pointer;
        }

        &::-webkit-slider-runnable-track {
            -webkit-appearance: none;
            appearance: none;
            border-radius: 4px;
            height: 4px;
            vertical-align: middle;
            border: none;
            cursor: pointer;
        }

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            border-radius: 100%;
            background-color: var(--color-red);
            height: 24px;
            width: 24px;
            vertical-align: middle;
            border: none;
            cursor: pointer;
            margin-top: -10px;
        }
    }

    .flex-container {
        display: flex;
    }
    
    .justify-c-between {
        justify-content: space-between;
    }

    .text-s {
        color: var(--color-text);
        font-size: 14px;
    }
}

</style>
  